<script setup lang="ts">
import { t } from '@/utils/i18n';
import TrxConsoleLogin from '@/components/TrxConsoleLogin.vue';

definePage({
  meta: {
    allowAnonymous: true,
  },
});
</script>

<template>
  <main class="trx-login-page max-w-lg mx-auto p-4 my-6 text-start space-y-5">
    <div>
      <h1 class="text-2xl font-semibold">{{ t('TRX live console') }}</h1>
      <p class="mt-2 text-sm text-muted">
        {{ t('Sign in to view live operation, research and diagnostics.') }}
      </p>
    </div>
    <section
      class="border border-default rounded-lg p-5 space-y-5"
      aria-labelledby="trx-login-heading"
    >
      <h2 id="trx-login-heading" class="text-lg font-semibold">{{ t('Log in to console') }}</h2>
      <TrxConsoleLogin />
    </section>
  </main>
</template>

<style scoped>
@media (max-width: 767px), (max-width: 1023px) and (max-height: 500px) {
  .trx-login-page {
    margin: 12px auto;
    padding: 12px;
  }
  .trx-login-page > section {
    padding: 16px;
  }
}
</style>
